import { atom } from "jotai";
import { getSidebarUserInfo } from "../../services/My/service";
import { getUserTypesFromToken } from "../../services/auth/authService";

export interface SidebarUser {
  full_name: string;
  username: string;
  avatarVisualType: string;
  userType: string;
}

export const sidebarUserAtom = atom<SidebarUser | null>(null);

export const fetchSidebarUserAtom = atom(
  null,
  async (_get, set) => {
    try {
      const userData = await getSidebarUserInfo();
      const types = getUserTypesFromToken();
      const visualType = types?.account_type || "default";

      set(sidebarUserAtom, {
        full_name: userData.full_name,
        username: userData.username,
        avatarVisualType: visualType,
        userType: types?.user_type || "unknown",
      });
    } catch (err) {
      console.error("Sidebar user info fetch failed", err);
    }
  }
);
